var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0763 23.75V16.25H6.57629C5.88594 16.25 5.32629 15.6904 5.32629 15C5.32629 14.3096 5.88594 13.75 6.57629 13.75H14.0763V6.25C14.0763 5.55964 14.6359 5 15.3263 5C16.0167 5 16.5763 5.55964 16.5763 6.25V13.75H24.0763C24.7666 13.75 25.3263 14.3096 25.3263 15C25.3263 15.6904 24.7666 16.25 24.0763 16.25H16.5763V23.75C16.5763 24.4404 16.0167 25 15.3263 25C14.6359 25 14.0763 24.4404 14.0763 23.75Z",
    fill: "#FDFEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.677b60eb21017618e5fb498ff887508a.svg";
export { ForwardRef as ReactComponent };